import { useState, useEffect, useCallback } from 'react';
import Constants from '../Constants';
import useAxios from './useAxios';

const useCompaniesOptions = ({ selectedTiers, selectedStatus, selectedAccountExecutive }) => {
    const { postData, isLoading } = useAxios();
    const [companiesOptions, setCompaniesOptions] = useState([]);

    const fetchFilteredCompanies = useCallback(async () => {
        const payload = {
            tier: selectedTiers,
            status: selectedStatus,
            accountExecutive: selectedAccountExecutive
        };

        const { success, data } = await postData(Constants.ApiUrl.companies.getCompaniesOptions, payload);
        if (success && data) {
            const formattedCompanies = data.map((company) => ({
                text: company.companyName,
                value: company._id
            }));
            setCompaniesOptions(formattedCompanies);
        }
    }, [postData, selectedTiers, selectedStatus, selectedAccountExecutive]);

    useEffect(() => {
        fetchFilteredCompanies();
    }, [fetchFilteredCompanies]);

    return {
        companiesOptions,
        isLoading
    };
};

export default useCompaniesOptions;
